package org.abhranilnxt.portfolio.models

enum class Skills(
    val icon: String,
    val imageDesc: String,
    val title: String,
    val description: String
) {
    Languages(
        icon = "languages_icon.svg",
        imageDesc = "Languages Icon",
        title = "Languages",
        description = "Kotlin, Java, C, C++"
    ),
    Technologies(
    icon = "technologies_icon.svg",
    imageDesc = "Technologies Icon",
    title = "Technologies",
    description = "Android, Jetpack Compose, Material3-UI, Retrofit, ROOM DB, Firebase, Coroutines, Kotlin Multiplatform, KTor, Git"
    ),
    Concepts(
        icon = "concepts_icon.svg",
        imageDesc = "Concepts Icon",
        title = "Concepts",
        description = "Object-oriented-programming, Dependency Injection, Android Lifecycle, MVVM"
    )
}